import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getLandingGeneralSettings,
  updateLandingGeneralSettingsRequest,
} from "../../../../services/api/landing/landingGeneralSettings/landingGeneralSettingsApi";

export const fetchLandingGeneralSettingsData = createAsyncThunk(
  "landingGeneralSettings/fetchLandingGeneralSettingsData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLandingGeneralSettings();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch landing general settings data");
    }
  },
);

export const updateLandingGeneralSettingsData = createAsyncThunk(
  "landingGeneralSettings/updateLandingGeneralSettingsData",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await updateLandingGeneralSettingsRequest(formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update landing general settings data");
    }
  },
);

const getLang = () => (localStorage.getItem("language") === "ar" ? "ar" : "en");

const toastMessages = {
  update: {
    en: "Landing general settings updated successfully!",
    ar: "تم تحديث إعدادات الصفحة الرئيسية بنجاح!",
  },
  updateError: {
    en: "Failed to update landing general settings.",
    ar: "فشل في تحديث إعدادات الصفحة الرئيسية.",
  },
};

const landingGeneralSettingsSlice = createSlice({
  name: "landingGeneralSettings",
  initialState: {
    landingGeneralSettingsData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandingGeneralSettingsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLandingGeneralSettingsData.fulfilled, (state, action) => {
        state.loading = false;
        state.landingGeneralSettingsData = action.payload;
      })
      .addCase(fetchLandingGeneralSettingsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateLandingGeneralSettingsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLandingGeneralSettingsData.fulfilled, (state, action) => {
        state.loading = false;
        state.landingGeneralSettingsData = action.payload;
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateLandingGeneralSettingsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      });
  },
});

export default landingGeneralSettingsSlice.reducer;
